export const vikasLogo = "/images/Logo.png";
export const Footer_logo = "/images/Footer_logo.png";
export const Vikas_logo = "/images/Vikas_logo.png";

export const vikasLogo2 = "/images/logo2.png";
//background image
export const Menu_bg = "/images/Menu_bg.svg";
export const home_image = "/images/home_Img.png";
export const home_Right = "/images/home_Right.png";
export const home_Left = "/images/home_Left.png";
export const Creative_fab = "/images/Creative_fab.png";
export const Red_textile_background =
  "/images/background_img/red_textile_background.png";
export const Background_about1 = "/images/background_img/background_about1.png";
export const Background_about2 = "/images/background_img/background_about2.png";
export const Background_about3 = "/images/background_img/background_about3.png";
export const Background_about4 = "/images/background_img/background_about4.png";
export const Testimonial_bg = "/images/background_img/testimonial_bg.png";
export const Media_img = "/images/background_img/media_img.png";
export const Faqs_img = "/images/background_img/faq_image.png";
export const Header_bg = "/images/background_img/header_bg.png";
export const particle_bg1 = "/images/background_img/particle_bg1.png";

// small object images
export const Red_Dots = "/images/common/red_dots.png";
export const Squre_Red_Dots = "/images/common/squre_red_dots.png";

export const Red_arrow = "/images/common/red_arrow.png";
export const Spring_arrow = "/images/common/spring_arrow.png";
export const Ring_circle = "/images/common/ring_circle.png";
export const Line_wave = "/images/common/line_wave.png";
export const Half_circle = "/images/common/half_circle.png";
export const Rectangle_dots = "/images/common/Rectangle_red_dots.png";
export const Wave_line = "/images/common/wave_line.png";
export const White_dots = "/images/common/white_dots.svg";
export const White_lines = "/images/common/white_lines.svg";

// image icon
export const Frame_icon = "/images/icons/Frame_icon.png";
export const Wave_icon = "/images/icons/Wave_icon.png";
export const Fabric_icon = "/images/icons/Fabric_icon.png";
export const People_icon = "/images/icons/People_icon.png";
export const Location_icon = "/images/icons/Location_icon.svg";
export const Envelope_icon = "/images/icons/Envelope.svg";
export const Phone_icon = "/images/icons/Phone_icon.svg";
export const White_envelope = "/images/icons/white_envelope.svg";
export const White_phone = "/images/icons/white_phone.svg";
export const User_icon = "/images/icons/user_icon.svg";
export const Info_icon = "/images/icons/Info_icon.svg";
export const Edit_icon = "/images/icons/Edit_icon.svg";
export const White_user = "/images/icons/white_user.svg";
export const White_info = "/images/icons/white_info.svg";
export const White_edit = "/images/icons/white_edit.svg";
export const WhiteLine_envelope = "/images/icons/whiteline_edit.svg";
export const WhiteLine_phone = "/images/icons/whiteLine_phone.svg";

//slider image
export const Slider_img_1 = "/images/Slider_img_1.png";
export const Slider_img_2 = "/images/Silder_img_2.png";
export const Slider_img_3 = "/images/Silder_img_3.png";
export const Slider_img_4 = "/images/Silder_img_4.png";
export const BG_IMG_1 = "/images/Bg_img1.png";

//avtar user icon
export const Avtar1 = "/images/icons/avtar1.svg";
export const Avtar2 = "/images/icons/avtar2.svg";

//ecard image
export const Ecard_img = "/images/ecards/Ecard.png";
export const Ecard_Atul = "/images/ecards/AtulJain.png";
export const Ecard_Siddhant = "/images/ecards/SiddhantJain.png";
export const Ecard_Vikas = "/images/ecards/vikasJain.png";
export const Ecard_Rahul = "/images/ecards/RahulJain.png";
export const Ecard_Mukesh = "/images/ecards/MukeshBhutra.png";
export const Ecard_Sajal = "/images/ecards/SajalRaghuvanshi.png";
